import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import { SuggestBox } from '../SuggestBox';
const FieldHeader = styled.div.withConfig({
  displayName: "EmailConfirmContent__FieldHeader",
  componentId: "osxv9j-0"
})(["margin-top:10px;"]);

var _ref = /*#__PURE__*/React.createElement(FieldHeader, null, "Subject:");

var _ref2 = /*#__PURE__*/React.createElement(FieldHeader, null, "Comments:");

export const EmailConfirmContent = ({
  siteEmailList,
  setEmailOption,
  emailOption,
  subject,
  onSubjectChange,
  comments,
  onCommentsChange
}) => {
  const list = siteEmailList ? siteEmailList.map(item => _objectSpread({
    label: item.recipientname
  }, item)) : [];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, "Select recipient:"), /*#__PURE__*/React.createElement(SuggestBox, {
    inputId: "email-recipient-select",
    editablePlaceholder: true,
    placeholder: "",
    options: list,
    onChange: option => setEmailOption(option || null),
    value: emailOption,
    menuPlacement: "bottom"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, "Email:", emailOption && ` ${emailOption.recipientemail}` || ''), _ref, /*#__PURE__*/React.createElement(TextField, {
    id: "email-subject",
    name: "emailSubject",
    placeholder: "",
    minRows: 1,
    maxRows: 4,
    onChange: e => onSubjectChange(e.target.value),
    value: subject,
    variant: "outlined",
    multiline: true,
    disabled: !emailOption
  }), _ref2, /*#__PURE__*/React.createElement(TextField, {
    id: "email-comments",
    name: "emailComments",
    placeholder: "",
    minRows: 2,
    maxRows: 90,
    onChange: e => onCommentsChange(e.target.value),
    value: comments,
    variant: "outlined",
    multiline: true,
    disabled: !emailOption
  }));
};